<h2>{{ title }}</h2>
<div class="logos">
  <a *ngFor="let area of featuredAreas" [href]="area.field_area_link">
    <div>
      <img [src]="area.field_area_image" [alt]="area.area_image_alt" [title]="area.area_image_title"/>
    </div>
  </a>
</div>